import { Button } from '@/common/ui/button'
import { type components, PlayerPlayLogStatus } from '@/schema'
import type { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { th } from 'date-fns/locale'
import { Link } from 'react-router-dom'

type AdminPlayLogItem = components['schemas']['AdminPlayLogItemResponse']

export const playLogsColumns: ColumnDef<AdminPlayLogItem>[] = [
	{
		id: 'playerInfo',
		header: 'ข้อมูลผู้เล่น',
		cell: ({ row }) => {
			return (
				<div className="space-y-1">
					<p>{row.original.playerPhone || '-'}</p>
					<p className="text-xs text-muted-foreground">
						ผู้ให้บริการ: {row.original.provider || '-'}
					</p>
					<p className="text-xs text-muted-foreground">
						เกม: {row.original.gameName || '-'}
					</p>
					<p className="font-mono text-xs text-muted-foreground">
						TX: {row.original.providerTransactionId || '-'}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'betAmount',
		header: 'ยอดเดิมพัน/ชำระ',
		cell: ({ row }) => {
			const settleAmount = row.original.settleAmount
			const isPositive = settleAmount >= 0
			return (
				<div className="space-y-1 text-left">
					<p>
						เดิมพัน:{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(row.original.betAmount)}
					</p>
					<p className={isPositive ? 'text-green-600' : 'text-red-600'}>
						ชำระ:{' '}
						{new Intl.NumberFormat('th-TH', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2,
						}).format(settleAmount)}
					</p>
				</div>
			)
		},
	},
	{
		accessorKey: 'transferIn',
		header: 'โอน/คงเหลือ',
		cell: ({ row }) => (
			<div className="space-y-1 text-left text-sm">
				<p>
					เข้า / ออก:{' '}
					{new Intl.NumberFormat('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(row.original.transferIn)}
					{' / '}
					{new Intl.NumberFormat('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(row.original.transferOut)}
				</p>
				<p className="text-muted-foreground">
					ก่อน / หลัง:{' '}
					{new Intl.NumberFormat('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(row.original.balanceBefore)}
					{' / '}
					{new Intl.NumberFormat('th-TH', {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(row.original.balanceAfter)}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'status',
		header: 'สถานะ/เวลา',
		cell: ({ row }) => {
			const status = row.original.status
			const createdAtText = row.original.createdAt
				? format(new Date(row.original.createdAt), 'dd MMM yyyy HH:mm:ss', {
						locale: th,
					})
				: '-'
			return (
				<div className="space-y-1">
					<span
						className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
							status === PlayerPlayLogStatus.SUCCESS
								? 'bg-green-100 text-green-800'
								: 'bg-red-100 text-red-800'
						}`}
					>
						{status}
					</span>
					<p className="text-xs text-muted-foreground">{createdAtText}</p>
				</div>
			)
		},
	},
	{
		id: 'details',
		header: 'รายละเอียด',
		cell: ({ row }) => (
			<Button asChild variant="outline">
				<Link
					to={`/operator/get-player-list/player-detail/${row.original.playerId}`}
				>
					ดูข้อมูลผู้เล่น
				</Link>
			</Button>
		),
	},
]
